export default __webpack_public_path__ + "static/media/ag-girl.bf5942b8.webp";